import React from 'react';
import {
  MenuList,
  MenuItem,
} from '@grnhse/seedling/lib/birch/components/expandable_menu';
import { withLocalePrefix } from 'shared/utils/translation';
import { useMyGreenhouseCandidate } from 'talent_matching/my_greenhouse/hooks/use_my_greenhouse_candidates';
import LazyEllipsisMenu from 'talent_matching/components/shared/lazy_ellipsis_menu';

const t = withLocalePrefix('talent_matching.rediscovery.table.actions');

type MyGreenhouseRowActionsProps = {
  candidateId: number;
};

const MyGreenhouseRowActions = ({
  candidateId,
}: MyGreenhouseRowActionsProps) => {
  const { candidate } = useMyGreenhouseCandidate(candidateId);

  if (!candidate) {
    return null;
  }

  const handleViewCandidate = () => {
    // Placeholder - actions will be implemented in future
  };

  const handleAddToJob = () => {
    // Placeholder - actions will be implemented in future
  };

  return (
    <LazyEllipsisMenu ariaLabel={t('actions')}>
      <MenuList>
        <MenuItem onSelect={handleViewCandidate} disabled>
          {t('view_candidate')}
        </MenuItem>
        <MenuItem onSelect={handleAddToJob} disabled>
          {t('add_to_job')}
        </MenuItem>
      </MenuList>
    </LazyEllipsisMenu>
  );
};

export default MyGreenhouseRowActions;
